
<video 
  #videoRef
  [style.view-transition-name]="'standby-video'"
  class="standby-page__video"
  src="/assets/fitur-2026/videos/standby.mp4" 
  width="100%"
  height="100%"
  autoplay 
  muted 
  loop
  playsinline
></video>